import React from 'react'
import { Grid } from '../../common/grid/Grid'
import { makeStyles, Text, tokens } from '@fluentui/react-components'
import { GridItem } from '../../common/grid/GridItem'
import { AnswerOptionAnalysisQuestion } from '../../../api/schemas/schema'
const useStyles = makeStyles({
   header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: tokens.spacingVerticalS,
   },
   column: {
      height: '800px',
      maxHeight: '90vh',
      scrollbarWidth: 'thin',
      scrollbarColor: `${tokens.colorBrandStroke2} transparent`,
      overflowY: 'auto',
      paddingTop: tokens.spacingVerticalL,
      '@media screen and (max-width: 1007px)': {
         height: '100%',
         '& > *': {
            display: 'flex',
            flexDirection: 'column',
         },
      },
   },
})

type DemandAnalysisQuestionCriteriaProps = {
   answerOptions: AnswerOptionAnalysisQuestion[]
}

export const DemandAnalysisQuestionCriteria = ({ answerOptions }: DemandAnalysisQuestionCriteriaProps) => {
   const classes = useStyles()

   return (
      <Grid className={classes.column}>
         {answerOptions &&
            answerOptions.map((option, index) => (
               <GridItem key={index} size="12/12">
                  <Text weight="semibold" className={classes.header} size={400}>
                     {option.text}
                  </Text>
                  <Text size={400}>{option.infoLabel}</Text>
               </GridItem>
            ))}
      </Grid>
   )
}
